<template>
  <component v-if="config.content && config.content.length"
             :is="renderCompName(config)"
             v-on="$listeners"
             v-bind="$attrs"
             :config="config">
    <render v-for="(item, i) in config.content" :config="item" :key="i" v-on="$listeners" />
  </component>
  <component v-else
             v-on="$listeners"
             v-bind="$attrs"
             :is="renderCompName(config)"
             :config="config" />
</template>

<script>
import Image from './Image';
import Title from './Title';
import Paragraph from './Paragraph';
import Text from './Text';
import ImageList from './ImageList';
import OrderedList from './OrderedList';
import BulletList from './BulletList';
import ListItem from './ListItem';
import Blockquote from './Blockquote';
import Horizontal from './Horizontal';
import Heading from './Heading';
import Audio from './Audio';
import Video from './Video';
import CodeBlock from './CodeBlock';
import HardBreak from './HardBreak';
import HtmlString from './HtmlString';

// 定义可支持组件
const supportComponents = [
  'title', 'paragraph', 'text', 'image', 'audio', 'video', 'image_list',
  'ordered_list', 'list_item', 'blockquote', 'horizontal_rule',
  'heading', 'code_block', 'bullet_list', 'hard_break', 'hashtag', 'mention',
  'html'
];

export default {
  name: 'Render',
  components: {
    'render-title': Title,
    'render-paragraph': Paragraph,
    'render-text': Text,
    'render-image': Image,
    'render-audio': Audio,
    'render-video': Video,
    'render-image-list': ImageList,
    'render-ordered-list': OrderedList,
    'render-list-item': ListItem,
    'render-blockquote': Blockquote,
    'render-horizontal-rule': Horizontal,
    'render-heading': Heading,
    'render-code-block': CodeBlock,
    'render-bullet-list': BulletList,
    'render-hard-break': HardBreak,
    'render-hashtag': Text,
    'render-mention': Text,
    'render-html': HtmlString
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return {
      inlineEls: ['text']
    };
  },
  computed: {},
  methods: {
    renderCompName(item){
      if (!item.type){
        return false;
      }
      if (supportComponents.includes(item.type)){
        return `render-${item.type.replace('_', '-')}`;
      }
      console.warn(`Content render warning: not support type of ${item.type}`);
      return 'render-paragraph';

    }
  },
  mounted(){
  }
};
</script>